__turbopack_context__.v({
  "actions": "ReservationWizard-module__eduPvW__actions",
  "back": "ReservationWizard-module__eduPvW__back",
  "calendar": "ReservationWizard-module__eduPvW__calendar",
  "calendarHeader": "ReservationWizard-module__eduPvW__calendarHeader",
  "calendarPanel": "ReservationWizard-module__eduPvW__calendarPanel",
  "calendarWeek": "ReservationWizard-module__eduPvW__calendarWeek",
  "choiceArrow": "ReservationWizard-module__eduPvW__choiceArrow",
  "confirmation": "ReservationWizard-module__eduPvW__confirmation",
  "confirmationIcon": "ReservationWizard-module__eduPvW__confirmationIcon",
  "contactForm": "ReservationWizard-module__eduPvW__contactForm",
  "content": "ReservationWizard-module__eduPvW__content",
  "dateHeading": "ReservationWizard-module__eduPvW__dateHeading",
  "empty": "ReservationWizard-module__eduPvW__empty",
  "formHint": "ReservationWizard-module__eduPvW__formHint",
  "fullWidth": "ReservationWizard-module__eduPvW__fullWidth",
  "heading": "ReservationWizard-module__eduPvW__heading",
  "layout": "ReservationWizard-module__eduPvW__layout",
  "noSlots": "ReservationWizard-module__eduPvW__noSlots",
  "progress": "ReservationWizard-module__eduPvW__progress",
  "reservation": "ReservationWizard-module__eduPvW__reservation",
  "resourceAvatar": "ReservationWizard-module__eduPvW__resourceAvatar",
  "resourceChoice": "ReservationWizard-module__eduPvW__resourceChoice",
  "resourceGrid": "ReservationWizard-module__eduPvW__resourceGrid",
  "resourceLocation": "ReservationWizard-module__eduPvW__resourceLocation",
  "resourceMeta": "ReservationWizard-module__eduPvW__resourceMeta",
  "schedule": "ReservationWizard-module__eduPvW__schedule",
  "search": "ReservationWizard-module__eduPvW__search",
  "serviceChoice": "ReservationWizard-module__eduPvW__serviceChoice",
  "serviceCopy": "ReservationWizard-module__eduPvW__serviceCopy",
  "serviceIcon": "ReservationWizard-module__eduPvW__serviceIcon",
  "serviceList": "ReservationWizard-module__eduPvW__serviceList",
  "serviceMeta": "ReservationWizard-module__eduPvW__serviceMeta",
  "signInHint": "ReservationWizard-module__eduPvW__signInHint",
  "slotLoading": "ReservationWizard-module__eduPvW__slotLoading",
  "slots": "ReservationWizard-module__eduPvW__slots",
  "spin": "ReservationWizard-module__eduPvW__spin",
  "stepNumber": "ReservationWizard-module__eduPvW__stepNumber",
  "steps": "ReservationWizard-module__eduPvW__steps",
  "summaryColumn": "ReservationWizard-module__eduPvW__summaryColumn",
  "summarySticky": "ReservationWizard-module__eduPvW__summarySticky",
  "textButton": "ReservationWizard-module__eduPvW__textButton",
  "textLink": "ReservationWizard-module__eduPvW__textLink",
  "timePanel": "ReservationWizard-module__eduPvW__timePanel",
  "timezone": "ReservationWizard-module__eduPvW__timezone",
  "unavailable": "ReservationWizard-module__eduPvW__unavailable",
});
